import { Component, Inject, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import * as _ from 'lodash'
@Component({
  selector: 'app-selection-award',
  templateUrl: './selection-award.component.html',
  styleUrls: ['./selection-award.component.css']
})
export class SelectionAwardComponent implements OnInit {

  accs = [{a:''}];
  remark: string = '';
  constructor(
    public dialogRef: MatDialogRef<SelectionAwardComponent>,
    private firestore: AngularFirestore,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    if (data.award) {
        this.accs = _.cloneDeep(data.award)
        this.remark = data.awardRemark

    }
  }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

  add() {
    this.accs.push({a:''})
  }

  delete(index) {
    this.accs.splice(index, 1)
  }
  select() {
    if (this.accs.find(e => !e)) {
      this.toast.error("Invalid award");
      return;
    }
    console.log(this.accs)

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '30%';

    const position = { top: '10%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm?';

    let info = {
      award: this.accs,
      awardRemark: this.remark
    }
    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if (data) {
        this.dialogRef.close(info)
      }
    })
  }

}
